import type { EventDescription } from '~/composables/types/event'
export const useAlgoliaConversion = () => {
  const { locale } = useI18n()
  const route = useRoute()
  const sendConversionEvents = async (kftEvent: EventDescription) => {
    /* @see https://www.algolia.com/doc/api-reference/api-methods/converted-object-ids/ */
    const queryId = route?.query?.qid?.toString() || null
    const { useAlgoliaSearchInsights } = await import(
      '~/composables/algolia/useAlgoliaSearchInsights'
    )
    const { client: algoliaInsightsClient, token } = useAlgoliaSearchInsights()

    try {
      algoliaInsightsClient('convertedObjectIDs', {
        userToken: token.value,
        index: getEventListIndexName(locale.value),
        eventName: 'Event Converted - Event page',
        ...(queryId && {
          queryId,
        }),
        objectIDs: ['EventDescription::' + eventGetters.getId(kftEvent)],
      })
    } catch (e) {
      console.error(e)
    }
  }

  const sendAddToCartEvent = async (event: EventDescription) => {
    const queryId = route?.query?.qid?.toString() || null
    const algoliaInsightsMethod = queryId
      ? 'addedToCartObjectIDsAfterSearch'
      : 'addedToCartObjectIDs'

    const { useAlgoliaSearchInsights } = await import(
      '~/composables/algolia/useAlgoliaSearchInsights'
    )
    const { client: algoliaInsightsClient, token } = useAlgoliaSearchInsights()

    try {
      algoliaInsightsClient(algoliaInsightsMethod, {
        userToken: token.value,
        index: getEventListIndexName(locale.value),
        eventName: 'Event added to cart - Event page',
        ...(queryId && {
          queryId,
        }),
        objectIDs: ['EventDescription::' + eventGetters.getId(event)],
      })
    } catch (e) {
      console.error(e)
    }
  }
  const sendViewEvents = async (event: EventDescription) => {
    const queryId = route.query.qid?.toString() || null

    const { useAlgoliaSearchInsights } = await import(
      '~/composables/algolia/useAlgoliaSearchInsights'
    )
    const { client: algoliaInsightsClient, token } = useAlgoliaSearchInsights()
    if (token) {
      try {
        /* @see https://www.algolia.com/doc/api-reference/api-methods/viewed-object-ids/ */
        algoliaInsightsClient('viewedObjectIDs', {
          userToken: token.value,
          ...(queryId && {
            queryId,
          }),
          index: getEventListIndexName(locale.value),
          eventName: 'Event Viewed - Event page',
          objectIDs: [
            'EventDescription::' + eventGetters.getId(event),
          ],
        })
      } catch (e) {
        console.error(e)
      }
    }
  }

  return {
    sendConversionEvents,
    sendAddToCartEvent,
    sendViewEvents,
  }
}
